import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { changeTopic } from '../../store/actions/topicActions'
import SignedInLinks from './SignedInLinks'
import SignedOutLinks from './SignedOutLinks'
import NavFilter from './NavFilter'

const Navibar = styled.nav`
  height: 100vh;
  width: 230px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: white;
  overflow-x: hidden;
  @media only screen and (max-width: 700px) {
    position: relative;
    height: 400px;
    width: 100vw;
  }
`
const BrandSquare = styled.div`
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  width: 100px;
  background: #df0e62;
  text-align: center;
`
const StyledLink = styled(Link)`
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  color: white;
  font-size: 25px;
  text-decoration: none;
`
const NaviList = styled.ul`
  padding: 0;
  text-align: center;
  li {
    list-style: none;
    padding: 10px 0;
  }
  li:hover {
    color: #0063c0;
  }
`
const NavbarLink = styled(NavLink)`
  font-family: 'Montserrat', sans-serif;
  text-decoration: none;
  font-size: 16px;
  font-weight: "light";
  color: black;
  :hover {
    color: green;
  }
`

const Navbar = (props) => {
  const { auth, changeTopic, match, location } = props;
  const signInLinks = auth.uid ? <SignedInLinks /> : <SignedOutLinks />;
  const links = location.pathname==="/signin" ? <div></div> : signInLinks;
  const navFilter = match.isExact ? <NavFilter /> : null
  return (
    <Navibar>
        <BrandSquare onClick={() => {changeTopic("")}}>
          <StyledLink to='/'>Learn Maps</StyledLink>
        </BrandSquare>
        {navFilter}
        <NaviList>
          <li><NavbarLink to='/create'>New Map</NavbarLink></li>
        </NaviList>
        {links}
    </Navibar>
  )
}

const mapStateToProps = (state) => {
  return{
    auth: state.firebase.auth,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    changeTopic: (topic) => dispatch(changeTopic(topic))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Navbar)



// WEBPACK FOOTER //
// ./src/components/navbar/Navbar.js